import React from "react";

// CSS-driven reveal (guaranteed visibility). The browser always completes the
// keyframe animation on mount, so content can never get stuck invisible the way
// JS/IntersectionObserver-based reveals can with smooth-scroll libraries.
export const Reveal = ({ children, delay = 0, className = "", y = 30 }) => (
  <div
    className={`reveal ${className}`}
    style={{ animationDelay: `${delay}s`, "--reveal-y": `${y}px` }}
  >
    {children}
  </div>
);

export default Reveal;
